export const normalizeDataMeasure = (
  payload: any,
  meta: any,
  measureTypeLookup: Record<string, string> = {},
) => {
  return {
    ...payload,
    measureNotes: payload.measureNotes ? payload.measureNotes.sort((prev: any, next: any) => {
        return next.timestamp - prev.timestamp;
      })
      : [],
    items: payload.items.map((element: any) => ({
      ...element,
      measureStatus: meta.measureStatus?.find((status: any) => status.id === element.statusId),
      measureType: element.type?.code ? (measureTypeLookup[element.type.code] ?? element.type.code) : '',
    })).sort((prev: any, next: any) => {
      return prev.type.genericTypeId - next.type.genericTypeId;
    })
  };
};

export const normalizeDataOperatorGroups = (payload: any) => {
 return payload ? payload.map((element: any) => ({
      ...element,
      groupName: element.group.name
    })) : [];
};